import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import { SubjectFacade } from '@app/core/facades/subject.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '212px';

@Component({
  selector: 'app-filter-subject',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class SubjectFilterComponent extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'Subject';

  constructor(private readonly _data: SubjectFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateSubjectId(value);
    this.valueChange.emit(new FilterChange(FilterType.Subject, value));
  }

  public ngOnInit(): void {
    this.options$ = (this.config.showAllSubjects ? this._data.subjects$ : this._data.subjectsMap$).pipe(
      distinctUntilChanged(),
      map((options) => options.map((option) => ({ label: `${option.name}`, value: option.id })))
    );

    this.initDefaultValues(this._data.subjectId$);
  }
}
